import React, { useContext } from "react";
import { DataContext } from "../../Context/DataContext";
import NoData from "../../NewComponents/NoData";
import { InstantSearch } from "react-instantsearch-hooks-web";
import { searchClientAlgolia } from "../../firebase.config";
import BackendInvoicesComponent from "./InvoicesComponent";

const OfficeInvoices = ({windowSize}) => {

  const { userData } = useContext(DataContext);
  
  if(!userData){
    return <NoData loading={true} showBtn={false} loadingText={"invoices"} type="order"/>
  }

  return (
    <>
    <InstantSearch searchClient={searchClientAlgolia} indexName="orderInvoices" >

      <BackendInvoicesComponent windowSize={windowSize}/>
    </InstantSearch>
  </>
  );
};

export default OfficeInvoices;
